import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import { TTRPG_SYSTEMS } from '../../data/ttrpgSystems';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';

function SystemSelectModal({ visible, onClose, onSelect, mode = 'dark' }) {
  const isDark = mode !== 'light';
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 620px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onClose}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4e7c5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 450,
        height: isPhone ? 'calc(100% - 114px)' : 490,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <div
          className='trialment_login_form_row'
          style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
        >
          Select TTRPG System
        </div>
        <div
          style={{
            flex: 1,
            overflowY: isPhone ? 'auto' : 'visible',
            paddingRight: '8px',
          }}
        >
          {TTRPG_SYSTEMS.filter((system) => system.id !== 'trialment').map((system) => (
            <span className='button_margin'>
              <Button
                key={system.id}
                icon={system.buttonIcon}
                label={system.name}
                type={system.buttonType}
                onPress={() => {
                  onSelect(system.id);
                  onClose();
                }}
              />
            </span>
          ))}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          <Button
            label='Cancel'
            type={isDark ? 'onyx' : 'black-white'}
            onPress={onClose}
          />
        </div>
      </div>
    </Rodal>
  );
}

export default SystemSelectModal;
